import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex, textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper:{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
    },

    header: {
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        display: 'flex',
        justifyContent: 'space-between',
        minHeight: 64,
        flex: '0 0 64px',
        alignContent: 'center',
        alignItems: 'center',
        padding: `${theme.spacing(3)} 0`,
    },

    contentTitle:{
        color: theme.colors.black,
        fontFamily: theme.font.primary,
        fontSize: '20px',
        marginLeft: '10px',
    },

    filters: {
        display: 'flex',
        alignItems: 'center',
    },

    filterIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
    },

    searchWrapper: {
        width: '100%',
        maxWidth: 312,
        [theme.down('mobile')]: {
            maxWidth: 'none',
        },
        marginRight: theme.spacing(4),
    },

    ellipsis: {
        ...textOverflowDots(),
    },

    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        height: 24,
        width: 24,
        ...flex('row', 'center', 'center'),

        '&:disabled': {
            opacity: 0.3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },

    tableWrapper: {
        flex: '1 1 0',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
}));